module.exports = __webpack_public_path__ + "static/media/avgora.67d78c21.mp3";